import { render } from "./updateMoneyDialog.vue?vue&type=template&id=2cd9e6b1"
import script from "./updateMoneyDialog.vue?vue&type=script&lang=js"
export * from "./updateMoneyDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__